module.exports = __webpack_public_path__ + "383a4fee51c9690678261dcbc029fc35.svg";